const _Hub_Name = "WorkFlowHub";

const _Invoke_Methods_Names = {
  // workflow template
  createWFTemplateName: "CreateWFTemplateLite",
  saveWFTemplate: "SaveWFTemplate",
  deleteWFTemplate: "DeleteWFTemplate",
  duplicateWFTemplate: "DuplicateWFTemplate",

  // default workflow template
  saveWFTBusinessCategories: "AddWFTemplateBusinessCategories",
  publishDefaultWFTemplate: "PublishDefaultWFTemplate",

  // workflows
  createWorkflowName: "CreateWorkflowLite",
  updateWorkflowName: "UpdateWorkflowName",
  saveWorkflow: "SaveWorkflow",
  deleteWorkflow: "DeleteWorkflow",
  duplicationWorkflow: "DuplicationWorkFlow",
  runWorkflow: "RunWorkflow",
  stopWorkflow: "StopWorkflow",
  addLeadsToWorkflow: "AddWorkflowLead",
  stopWorkFlowLead: "StopWorkFlowLead",
  removeWorkflowLead: "RemoveWorkflowLead",
};

const _OnReceive_Methods_Names = {
  // workflow template
  onCreateWFTemplateName: "CreateWFTemplateLiteResponse",
  onSaveWFTemplate: "SaveWFTemplateResponse",
  onDeleteWFTemplate: "DeleteWFTemplateResponse",
  onDuplicateWFTemplate: "DuplicateWFTemplateResponse",

  // default workflow template
  onSaveWFTBusinessCategories: "SaveWFTemplateBusinessCategoriesResponse",
  onPublishDefaultWFTemplate: "PublishDefaultWFTemplateResponse",

  // workflows
  onCreateWorkflowName: "CreateWorkflowLiteResponse",
  onUpdateWorkflowName: "UpdateWorkflowNameResponse",
  onSaveWorkflow: "SaveWorkflowResponse",
  onDeleteWorkflow: "DeleteWorkflowResponse",
  onDuplicationWorkflow: "DuplicationWorkFlowResponse",
  onRunWorkflow: "WorkflowRunResponse",
  onStopWorkflow: "StopWorkflowResponse",
  addLeadsToWorkflowResponse: "AddWorkflowLeadResponse",
  stopWorkFlowLeadResponse: "StopWorkFlowLeadResponse",
  removeWorkflowLeadResponse: "RemoveWorkflowLeadResponse",
};

const WF_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default WF_signalr;
